import { render } from "./StatisticalReport.vue?vue&type=template&id=736f0e8e&scoped=true"
import script from "./StatisticalReport.vue?vue&type=script&lang=js"
export * from "./StatisticalReport.vue?vue&type=script&lang=js"

import "./StatisticalReport.vue?vue&type=style&index=0&id=736f0e8e&scoped=true&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736f0e8e"]])

export default __exports__